import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';
import { collectCell, getPercent } from '../../../../helpers/showDelta';

export const COLUMNS = (t) => [
    {
        label: t('search.comparison.overallPerformance.columns.device'),
        key: 'device',
        data: 'device',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{data}</strong>;
        },
    },
    {
        label: t('search.comparison.overallPerformance.columns.impressions'),
        key: 'impressions',
        data: 'impressions',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: <span className="delta-sign">&#916;</span>,
        key: 'impressions_delta',
        data: 'impressions_delta',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return getPercent(item.impressions, item.impressionsPrior);
            return collectCell(item.impressions, item.impressionsPrior);
        },
    },
    {
        label: t('search.comparison.overallPerformance.columns.clicks'),
        key: 'clicks',
        data: 'clicks',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: <span className="delta-sign">&#916;</span>,
        key: 'clicks_delta',
        data: 'clicks_delta',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return getPercent(item.clicks, item.clicksPrior);
            return collectCell(item.clicks, item.clicksPrior);
        },
    },
    {
        label: t('search.comparison.overallPerformance.columns.position'),
        key: 'avgPosition',
        data: 'avgPosition',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: <span className="delta-sign">&#916;</span>,
        key: 'avgPosition_delta',
        data: 'avgPosition_delta',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return getPercent(item.avgPosition, item.avgPositionPrior);
            return collectCell(item.avgPosition, item.avgPositionPrior);
        },
    },
    {
        label: t('search.comparison.overallPerformance.columns.ctr'),
        key: 'avgCTR',
        data: 'avgCTR',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            const ctrValue = item.clicks / item.impressions;
            if (csvDownload) return ctrValue;
            return <strong>{numeral(ctrValue).format('0.00%')}</strong>;
        },
    },
    {
        label: <span className="delta-sign">&#916;</span>,
        key: 'avgCTR_delta',
        data: 'avgCTR_delta',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return getPercent(item.avgCTR, item.avgCTRPrior);
            return collectCell(item.avgCTR, item.avgCTRPrior);
        },
    },
];

export const chart_keys = (t) => [
    {
        key: 'clicksL',
        label: t('search.comparison.overallPerformance.chart.clicks'),
        icon: 'pagev-view',
    },
    {
        key: 'impressionsL',
        label: t('search.comparison.overallPerformance.chart.impressions'),
        icon: 'search',
        hidden: true,
    },
    {
        key: 'ctrL',
        label: t('search.comparison.overallPerformance.chart.avgCtr'),
        format: '0.00%',
        render: (data) => numeral(data * 100).format('0.00'),
        icon: 'ctr',
        yAxisID: 'y1',
        hidden: true,
    },
    {
        label: t('search.comparison.overallPerformance.chart.position'),
        key: 'positionL',
        yAxisID: 'y2',
        icon: 'clicks',
        hidden: true,
    },
];

export const TAGS = ['MOBILE', 'DESKTOP', 'TABLET'];
